import React, { useState } from "react";
import clienteAxios from "../../axios"; // Asegúrate de que esta sea la ruta correcta

const ModalAgregarPedido = ({ show, onClose, cocinaId, onPedidoAgregado }) => {
    const [nuevoPedido, setNuevoPedido] = useState({
        comanda_id: "",
        estado: "Pendiente"
    });

    const handleAgregarPedido = async (e) => {
        e.preventDefault();
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "pedidos_cocina",
                cocina_id: cocinaId,  // Relacionamos el nuevo pedido con la cocina
                comanda_id: nuevoPedido.comanda_id,  // ID de la comanda
                estado: nuevoPedido.estado  // Estado del pedido (por defecto 'Pendiente')
            });
            setNuevoPedido({ comanda_id: "", estado: "Pendiente" });
            onPedidoAgregado();  // Actualizamos la lista después de agregar
            onClose();  // Cerramos el modal
        } catch (error) {
            console.log(error);
        }
    };

    if (!show) {
        return null;  // No renderizamos el modal si show es false
    }

    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg">
                <h2 className="text-lg font-semibold mb-4">Agregar Nuevo Pedido</h2>
                <form onSubmit={handleAgregarPedido}>
                    <input
                        type="number"
                        placeholder="ID de la Comanda"
                        value={nuevoPedido.comanda_id}
                        onChange={(e) => setNuevoPedido({ ...nuevoPedido, comanda_id: e.target.value })}
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={10}
                    />
                    <button type="submit" className="bg-green-500 text-white px-4 py-2 rounded mr-2">
                        Agregar Pedido
                    </button>
                    <button type="button" onClick={onClose} className="bg-gray-500 text-white px-4 py-2 rounded">
                        Cancelar
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ModalAgregarPedido;
